import { O as Observable, D as DOM } from './vivid-element.js';

class AttributeBindingBehavior {
  constructor(target, binding, isBindingVolatile, attributeName) {
    this.target = target;
    this.binding = binding;
    this.isBindingVolatile = isBindingVolatile;
    this.attributeName = attributeName;
    this.source = null;
    this.context = null;
  }
  bind(source, context) {
    this.source = source;
    this.context = context;
    if (!this.bindingObserver) {
      this.bindingObserver = Observable.binding(
        this.binding,
        this,
        this.isBindingVolatile
      );
    }
    this.updateTarget(this.bindingObserver.observe(source, context));
  }
  unbind() {
    this.bindingObserver.disconnect();
    this.source = null;
    this.context = null;
  }
  handleChange() {
    this.updateTarget(
      this.bindingObserver.observe(this.source, this.context)
    );
  }
  updateTarget(value) {
    DOM.setAttribute(this.target, this.attributeName, value);
  }
}

export { AttributeBindingBehavior as A };
